import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {
  transform<T extends object>(array: T[], field: string): T[] {
    if (!Array.isArray(array)) {
      return array;
    }

    const getFieldValue = (item: T): unknown => {
      return (item as Record<string, unknown>)[field];
    };

    return array.sort((a, b) => {
      const aValue = getFieldValue(a);
      const bValue = getFieldValue(b);

      if (aValue === bValue) {
        return 0;
      }

      if (aValue === null || aValue === undefined) {
        return -1;
      }

      if (bValue === null || bValue === undefined) {
        return 1;
      }

      if (typeof aValue === 'number' && typeof bValue === 'number') {
        return aValue - bValue;
      }

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return aValue.localeCompare(bValue);
      }

      if (`${aValue}` < `${bValue}`) {
        return -1;
      } else if (`${aValue}` > `${bValue}`) {
        return 1;
      } else {
        return 0;
      }
    });
  }
}
